const PRODUCTION_DOMAIN = "turo.com";
const isProductionDomain =
  typeof document !== "undefined" &&
  (document.location.hostname === PRODUCTION_DOMAIN ||
    document.location.hostname.endsWith(`.${PRODUCTION_DOMAIN}`));

const config = {
  GOOGLE_CAPTCHA_SITE_KEY: isProductionDomain
    ? "6Lc_osgUAAAAAHrdC_7s0CsU5wWgwdLyI8HpNUom"
    : "6LfbeMgUAAAAAFzX_C3fHpJD-8WTMUvj8om2rkcN",
  LOCALE_TO_TRANSLATIONS_LOCALE: {
    en_AU: "en_US",
    en_CA: "en_US",
    en_GB: "en_US",
    en_US: "en_US",
    fr_CA: "fr_CA",
    fr_FR: "fr_FR",
  },
  DEFAULT_LOCALE: "en_US",
} as const;

export default config;
